import { render, staticRenderFns } from "./layout-section-product-gallery.vue?vue&type=template&id=735f9f6c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&xmlns%3Av-touch=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./layout-section-product-gallery.vue?vue&type=script&lang=js&"
export * from "./layout-section-product-gallery.vue?vue&type=script&lang=js&"
import style0 from "./layout-section-product-gallery.vue?vue&type=style&index=0&id=735f9f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735f9f6c",
  null
  
)

export default component.exports